import React from "react"; //eslint-disable-line
import { Route, Redirect, withRouter } from "react-router-dom"; //eslint-disable-line
import jwt from "jsonwebtoken";
import store from "./redux/store";
import secrets from "./configs/secrets/CRYPTO_KEYS";

//Redux
import { connect } from "react-redux";
import * as authActions from "./redux/actions/authActions";
//eslint-disable-next-line
const PrivateRoute = ({ component: Component, auth, ...rest }) => {
  // During refresh: If found in localStorage and is not logged in(redux store) and token is valid
  if (auth.token) {
    try {
      jwt.verify(auth.token, `${secrets.publicKey}`);
    } catch (e) {
      if (e.name !== "NotBeforeError") {
        store.dispatch(authActions.logout());
      }
    }
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        const { location } = props;
        if (!auth.isLoggedIn && location.pathname !== "/login") {
          const redirectUrl = location.pathname + location.search;
          return (
            <Redirect
              to={{
                pathname: "/login",
                search: `?redirectUrl=${encodeURIComponent(redirectUrl)}`,
              }}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  auth: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));
